import { render, staticRenderFns } from "./UrlifyText.vue?vue&type=template&id=a35449ae&"
import script from "./UrlifyText.vue?vue&type=script&lang=js&"
export * from "./UrlifyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports